import { styled, IconButton } from '@mui/material'

const StyledIconButton = styled(IconButton)`
  position: fixed;
  right: 0px;
  top: 33%;
  z-index: 10;
  background-color: lightgray;
  :hover {
    background-color: lightgray;
  }
  border-radius: 8px 0px 0px 8px;
`
const StyledImg = styled('img')`
  width: 86px;
  height: 92px;
  margin: auto;
  margin-right: 0.4rem;
`
const StyledP = styled('p')`
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
`
export { StyledIconButton, StyledImg, StyledP }
